import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * tailwind-merge only knows Tailwind's default scales. Our type scale (`text-caption`,
 * `text-body`, …) and elevation (`shadow-e2`, `shadow-glow-cyan`, …) are custom names, so by
 * default it filed `text-caption` under text COLOUR and dropped the colour next to it:
 * `bg-cyan text-void` + `text-caption` lost `text-void` (primary label inherited white on
 * cyan, 1.6:1) and a badge's `text-micro` lost to `text-ok`. Registering the scales keeps
 * size and colour apart (tailwind.config.ts `fontSize` / `boxShadow`).
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'micro',
            'caption',
            'body',
            'body-lg',
            'title-2',
            'title-1',
            'display-2',
            'display-1',
          ],
        },
      ],
      shadow: [{ shadow: ['e2', 'e3', 'glow-cyan', 'glow-magenta'] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Money and percentages always render with tabular figures.
 *  @deprecated Use lib/format (`fmtCredits`, `fmtMoney`, `fmtUsdt`): they take the API's
 *  decimal strings without a float (WP-04). Kept for compatibility; nothing in src uses these. */
export function formatCredits(value: number): string {
  return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(value)
}

/** @deprecated Use `fmtMoney(v, 'RUB')` from lib/format (WP-04). */
export function formatRub(value: number): string {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 0,
  }).format(value)
}

/** @deprecated Use `fmtUsdt` from lib/format (WP-04). */
export function formatUsdt(value: number): string {
  return `${new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(value)} USDT`
}
